import { DictionaryLaboratory, ExtractLaboratory, LoadingStatusEnum, DictionaryLaboratorySchema, ExtractLaboratorySchema } from "etl/types";
import { createAppAsyncThunk } from "core/src/store/store.types";
import { displayApiErrorToast } from "core/src/slices/ui/useCases/display-api-error-toast/display-api-error-toast.use-case";

export type LoadLaboratoryRequest = {
	forceReload?: boolean
} | void;

type LoadLaboratoriesResponse = {
	extractLaboratories: ExtractLaboratory[];
	dictionaryLaboratories: DictionaryLaboratory[];
};

export const loadLaboratories = createAppAsyncThunk<LoadLaboratoriesResponse, LoadLaboratoryRequest>(
	"etlData/loadLaboratories",
	async (_, { extra, rejectWithValue, dispatch, getState }) => {
		const { selectedEtlImportUuid } = getState().etlData;

		if (!selectedEtlImportUuid) {
			return rejectWithValue("No etl import selected");
		}

		try {
			const [dictionaryLaboratories, extractLaboratories] = await Promise.all([
				extra.etlClient.findAll(DictionaryLaboratorySchema, { params: { etlImportUuid: selectedEtlImportUuid } }),
				extra.etlClient.findAll(ExtractLaboratorySchema, { params: { etlImportUuid: selectedEtlImportUuid } }),
			]);

			return {
				extractLaboratories,
				dictionaryLaboratories,
			}
		} catch (error) {
			dispatch(displayApiErrorToast(error));
			return rejectWithValue(error);
		}
	},
	{
		condition: (data, { getState }) => {
			if (data?.forceReload) return true;
			if (!getState().etlData.selectedEtlImportUuid) return false;
			return [LoadingStatusEnum.NotLoaded, LoadingStatusEnum.Error].includes(getState().etlData.laboratoriesLoadingStatus);
		}
	}
);
